import { render, staticRenderFns } from "./NewSite.vue?vue&type=template&id=327e07de&scoped=true&"
import script from "./NewSite.vue?vue&type=script&lang=js&"
export * from "./NewSite.vue?vue&type=script&lang=js&"
import style0 from "./NewSite.vue?vue&type=style&index=0&id=327e07de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e07de",
  null
  
)

export default component.exports